module.exports = __webpack_public_path__ + "img/hourglass.6c99ed08.svg";